import { FormControl, Validators } from "react-reactive-form";
import { ErrorUI } from "../components/UI/Modals/Modals";
import { CheckImageType, CheckValue, formatBytes } from "./CommonFunction";
import { extractImageFileExtensionFromBase64 } from "./ResuableUtils";

export const getData = (data, filterKey = "value", string_return = true) => {
  if (Array.isArray(data)) {
    if (string_return) {
      return data[0][filterKey];
    } else {
      return data.map((el) => el[filterKey]);
    }
  } else if (typeof data === "string") {
    return data;
  } else {
    if (string_return) {
      return data[filterKey];
    } else {
      return [data[filterKey]];
    }
  }
};

export const touched = (key, form, status = "group") => {
  if (status === "group") {
    form.get(key).markAsTouched({ emitEvent: true });
    form.markAsTouched({ emitEvent: true });
  } else {
    form.get(key).markAsTouched({ emitEvent: true });
    form.markAsTouched({ emitEvent: true });
  }
};

export const imageForm = (data = null, status = true) => ({
  value: new FormControl(
    data ? data[data.keyValue] : null,
    status ? [Validators.required] : []
  ),
  image: new FormControl(data ? data.thumb : ""),
  thumb: new FormControl(data ? data.thumb : ""),
  original: new FormControl(data ? data.original : ""),
  upload: new FormControl(false),
  label: new FormControl(""),
  imgSrc: new FormControl(""),
  imgSrcExt: new FormControl(""),
  crop: new FormControl(data && data.crop ? data.crop : ""),
});

export const imgUpload = (event, form, formKey) => {
  if (event.target.files.length) {
    if (CheckImageType(event.target.files[0].type)) {
      if (
        formatBytes(event.target.files[0].size, 2, { sizeType: "MB", size: 2 })
      ) {
        const currentFile = event.target.files[0];
        const myFileItemReader = new FileReader();
        let imgSrc = null;
        let imgSrcExt = null;
        myFileItemReader.addEventListener(
          "load",
          () => {
            const myResult = myFileItemReader.result;
            imgSrc = myResult;
            imgSrcExt = extractImageFileExtensionFromBase64(myResult);
          },
          false
        );
        myFileItemReader.readAsDataURL(currentFile);

        setTimeout(() => {
          let data = {
            value: currentFile,
            image: URL.createObjectURL(currentFile),
            thumb: URL.createObjectURL(currentFile),
            original: URL.createObjectURL(currentFile),
            imgSrc: imgSrc,
            imgSrcExt: imgSrcExt,
            crop: {
              aspect: 2 / 1,
              height: 50,
              width: 50,
              unit: "%",
              x: 0,
              y: 0,
            },
          };
          setImageData(
            { file: currentFile, crop: data.crop },
            data,
            form,
            formKey
          );
        }, 500);
        event.target.value = null;
        return { status: true, error: "", data: true };
      } else {
        event.target.value = null;
        return {
          status: false,
          error: "Maximum upload image size: 2 MB.",
        };
      }
    } else {
      event.target.value = null;
      return {
        status: false,
        error: "Image not supported. Please try with different image.",
      };
    }
  }
};

export const setImageData = (el, data, form, formKey) => {
  const temp = {
    value: el.file,
    image: URL.createObjectURL(el.file),
    thumb: URL.createObjectURL(el.file),
    original: URL.createObjectURL(el.file),
    upload: true,
    imgSrc: data.imgSrc,
    imgSrcExt: data.imgSrcExt,
    crop: el.crop,
    label: "",
  };
  if (CheckValue(form)) {
    form.patchValue({ [formKey]: temp });
    touched(formKey, form);
  }
  // return temp;
};

export const setEditImage = (activityLogo) => ({
  value: activityLogo[activityLogo.keyValue],
  image: activityLogo.thumb,
  thumb: activityLogo.thumb,
  original: activityLogo.original,
  upload: false,
  imgSrc: "",
  imgSrcExt: "",
  crop: "",
  label: "",
});

export const setDefaultEditImage = () => ({
  value:
    "http://d3hzmbpns6m9lm.cloudfront.net/247a1ed2-04b3-4d8a-b894-3fc9cd82bc4c/misc/activity_image/1641331556814/original-activity_image-1641331554632-529733277.jpeg",
  image:
    "http://d3hzmbpns6m9lm.cloudfront.net/247a1ed2-04b3-4d8a-b894-3fc9cd82bc4c/misc/activity_image/1641331556814/original-activity_image-1641331554632-529733277.jpeg",
  thumb:
    "http://d3hzmbpns6m9lm.cloudfront.net/247a1ed2-04b3-4d8a-b894-3fc9cd82bc4c/misc/activity_image/1641331556814/original-activity_image-1641331554632-529733277.jpeg",
  original:
    "http://d3hzmbpns6m9lm.cloudfront.net/247a1ed2-04b3-4d8a-b894-3fc9cd82bc4c/misc/activity_image/1641331556814/original-activity_image-1641331554632-529733277.jpeg",
  upload: false,
  imgSrc: "",
  imgSrcExt: "",
  crop: "",
  label: "",
});

export const checkKg_Pound = (el, weight_value, status = false) => {
  if (!CheckValue(weight_value) || weight_value === 0) {
    return weight_value;
  }
  const number = 2.2046;
  let new_value = Number(weight_value);
  if (el === "Kg") {
    if (!status) {
      new_value = new_value / number;
    }
  } else {
    new_value = new_value * number;
  }
  return new_value.toFixed(1);
};

export const checkCm_Feet = (el, height_value, status = false) => {
  if (!CheckValue(height_value) || height_value === 0) {
    return height_value;
  }

  const number = 2.54;
  const one_cm = 12;
  let new_value = height_value.replace(/'/g, ".");
  new_value = new_value.replace('"', "");

  if (el === "CMs") {
    if (!status) {
      const temp_number = new_value.split(".");
      let new_number = temp_number[0] * one_cm;
      new_number += Number(temp_number[1] || 0);
      new_value = (new_number * number).toFixed(2);
    }
  } else {
    let new_number = new_value / number;
    new_value = Math.floor(new_number / one_cm);
    let temp = new_value * one_cm;
    temp = new_number - temp;
    new_value = new_value + "." + temp;
    new_value = new_value.replace(".", "'");
    new_value = new_value + '"';
  }
  console.log("new_value", new_value);
  return new_value;
};

export const checkFT_value = (el) => {
  const input_value = el.replace(".", "'").replace('"', "");
  let height_value = input_value;
  // console.log(el.length, el);
  if (el.length === 2) {
    if (!input_value.includes("'")) {
      height_value = input_value.slice(0, 1) + "'" + input_value.slice(1);
      if (height_value.length === 3) {
        height_value = height_value + '"';
      }
    }
  } else if (el.length === 3) {
    height_value = input_value.slice(0, 1);
  } else if (el.length === 4) {
    height_value = input_value.slice(0, 3) + '"';
  } else if (el.length === 5) {
    height_value = input_value.slice(0, 4) + '"';
  }
  return height_value;
};

export const height_weight_subscriber = (status, form) => {
  form.get("weight_unit").valueChanges[status]((el) => {
    let weight_value = form.value.weight_value;
    if (CheckValue(weight_value)) {
      weight_value = checkKg_Pound(getData(el), weight_value);
      form.patchValue({ weight_value: weight_value });
      touched("weight_value", form);
    }
  });

  form.get("height_unit").valueChanges[status]((el) => {
    let height_value = form.value.height_value;
    if (CheckValue(height_value) && height_value.length >= 1) {
      height_value = checkCm_Feet(getData(el), height_value);
      form.patchValue({ height_value });
      touched("height_value", form);
    }
  });

  form.get("height_value").onValueChanges[status]((el) => {
    if (el.length > 1) {
      if (getData(form.value.height_unit) === "Feet") {
        const height_value = checkFT_value(el);
        form.patchValue({ height_value });
        touched("height_value", form);
      } else if (!el.includes(".")) {
        let height_value = el;
        if (el.length === 4) {
          height_value = height_value.slice(0, 3) + "." + height_value.slice(3);
        }
        form.patchValue({ height_value });
        touched("height_value", form);
      }
    }
  });
};
